export default __webpack_public_path__ + "static/media/Entencup.6aaa31f5.png";